import React from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import PendingDeviceCard from "./PendingDeviceCard";

const DeviceGridPending = ({ devices = [], loading = false }) => {
  const showSkeletons = loading || devices.length === 0;

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
        gap: 2,
      }}
    >
      {showSkeletons
        ? Array.from({ length: 6 }).map((_, i) => (
            <PendingDeviceCard key={`skeleton-${i}`} loading />
          ))
        : devices.map((device) => (
            <PendingDeviceCard key={device.id} device={device} />
          ))}
    </Box>
  );
};

DeviceGridPending.propTypes = {
  devices: PropTypes.array.isRequired,
  loading: PropTypes.bool,
};

export default DeviceGridPending;
